import { AlertService } from '@aurelia-toolkit/alert';
import { ValidationController } from 'aurelia-validation';

export interface IWithValidationController {
  validationController: ValidationController;
  alertService?: AlertService;
}

/**
 *
 * @param errorMessage Optional error message, not displayed if `null`
 */
export function validate(errorMessage?: string | undefined | null) {
  return function validateDecorator<T>(_target: IWithValidationController, _propertyKey: string, descriptor: TypedPropertyDescriptor<(this: IWithValidationController, ...args: unknown[]) => Promise<T>>) {
    const originalMethod = descriptor.value;
    if (originalMethod !== undefined) {
      descriptor.value = async function validate(this: IWithValidationController, ...args) {
        if (!this.validationController) {
          throw new Error('Did you forget to create ValidationController?');
        }
        const errors = await this.validationController.validate();
        if (!errors.valid) {
          if (errorMessage !== null && this.alertService) {
            await this.alertService.error(errorMessage ?? 'Please fix validation errors');
          }
          return;
        }
        return originalMethod.apply(this, args) as Promise<T>;
      };
    }
    return descriptor;
  };
}


// export function validate(errorMessage?: string | undefined | null) {
//   return function validateDecorator<T>(_target: IWithValidationController, _propertyKey: string, descriptor: TypedPropertyDescriptor<(this: IWithValidationController, ...args: unknown[]) => Promise<T>>) {
//     const originalMethod = descriptor.value;
//     if (originalMethod !== undefined) {
//       descriptor.value = async function validate(this: IWithValidationController, ...args) {
//         if (!this.validationController) {
//           throw new Error('Did you forget to create ValidationController?');
//         }
//         const currentCtx = context.active();
//         const errors = await this.validationController.validate();
//         if (!errors.valid) {
//           if (errorMessage !== null && this.alertService) {
//             await this.alertService.error(errorMessage ?? 'Please fix validation errors');
//           }
//           return;
//         }
//         // Use context.with to ensure the original method is called with the correct context
//         return context.with(currentCtx, () => originalMethod.apply(this, args)) as Promise<T>;
//       };
//     }
//     return descriptor;
//   };
// }
